export const ChipGroup = ({ options, value, onChange, testPrefix, getLabel = (o) => o }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        key={o}
        type="button"
        data-testid={`${testPrefix}-${String(o).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        onClick={() => onChange(o)}
        className={`min-h-[36px] rounded-lg border px-3 text-xs font-medium transition-colors duration-150 ${
          value === o ? "border-[#1F9E7A] bg-[#1F9E7A] text-white" : "border-neutral-200 bg-white text-neutral-600 hover:border-neutral-400"
        }`}
      >
        {getLabel(o)}
      </button>
    ))}
  </div>
);
